import { cn } from "@/lib/utils";

interface PasswordStrengthMeterProps {
  password: string;
}

type Strength = { score: number; label: string; color: string; bar: string };

function getStrength(password: string): Strength {
  const rules = [
    password.length >= 8,
    /[A-Z]/.test(password),
    /[0-9]/.test(password),
    /[^A-Za-z0-9]/.test(password),
  ];
  const score = rules.filter(Boolean).length;

  if (score <= 1) return { score, label: "Weak",      color: "text-red-400",    bar: "bg-red-500" };
  if (score === 2) return { score, label: "Fair",      color: "text-orange-400", bar: "bg-orange-500" };
  if (score === 3) return { score, label: "Strong",    color: "text-yellow-400", bar: "bg-yellow-400" };
  return             { score, label: "Very Strong", color: "text-green-400",  bar: "bg-green-500" };
}

export function PasswordStrengthMeter({ password }: PasswordStrengthMeterProps) {
  if (!password) return null;

  const { score, label, color, bar } = getStrength(password);

  return (
    <div className="space-y-1.5">
      <div className="flex gap-1">
        {[1, 2, 3, 4].map((seg) => (
          <div
            key={seg}
            className={cn(
              "h-1 flex-1 rounded-full transition-all duration-300",
              seg <= score ? bar : "bg-white/10"
            )}
          />
        ))}
      </div>
      <p className={cn("text-xs font-medium", color)}>{label}</p>
    </div>
  );
}
